export default __webpack_public_path__ + "static/media/criancas-acao.7fb2da63.jpg";